<template>
  <div class="grid">
    <div class="grid-body p-3">
      <v-row align="center" class="pb-3">
        <v-col sm="4">
          <v-text-field
            v-model="keyword"
            :label="$t('ENTER_RESTRICTION_NAME_OR_CODE')"
            v-on:keyup="getAll(1)"
            class="mt-0 pt-0"
          ></v-text-field>
        </v-col>
        <v-col sm="5">
          <v-radio-group v-model="status" row class="mt-0" @change="getAll(1)">
            <v-radio
              :label="$t('ALL')"
              value="all"
            ></v-radio>
            <v-radio
              :label="$t('ACTIVE')"
              value="1"
            ></v-radio>
            <v-radio
              :label="$t('DEACTIVE')"
              value="0"
            ></v-radio>
          </v-radio-group>
        </v-col>
        <v-col sm="3" class="text-right">
          <v-btn color="primary" @click="addNew">
            <v-icon dark>
              mdi-plus
            </v-icon>
            {{ $t("ADD_NEW_RESTRICTION") }}
          </v-btn>
        </v-col>
      </v-row>
      <v-progress-linear
        color="warning"
        indeterminate
        rounded
        height="3"
        v-if="isLoading"
      ></v-progress-linear>

      <v-simple-table>
        <template v-slot:default>
          <thead>
            <tr>
              <th v-for="header in headers" :class="header.class">
                <template
                  v-if="header.value == 'status'"
                  @click="sortStatus(asc, 1)"
                  style="cursor: pointer"
                  >{{ header.text }}</template
                >
                <template v-else>{{ header.text }}</template>
              </th>
            </tr>
          </thead>
          <tbody>
            <template v-if="dataTable.length > 0 && !isLoading">
              <tr v-for="(item, i) in dataTable">
                <td class="text-center vertical-middle">{{ paging.offset + i + 1 }}</td>
                <td class="vertical-middle font-weight-bold">
                  <a
                    class="app-link"
                    href="javascript:;"
                    @click="editItem(item)"
                    v-if="item.restrictionPlanI18n.filter(x => x.lang == defaultI18n).length > 0" 
                  >
                    {{
                      item.restrictionPlanI18n.find(x => x.lang == defaultI18n)
                        .name
                    }}
                  </a>
                </td>
                <td class="text-center vertical-middle">
                  <div class="d-flex justify-center">
                    <v-switch
                      v-model="item.status"
                      class="item-switch m-0 p-0 align-center"
                      @change="changeStatus(item)"
                    ></v-switch>
                  </div>
                </td>
                <td class="text-center vertical-middle">
                  <v-tooltip top transition="slide-y-reverse-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        depressed
                        @click="editItem(item)"
                        x-small
                        class="rounded-sm mr-1"
                        v-bind="attrs"
                        v-on="on"
                        color="primary"
                        outlined
                      >
                        <v-icon size="15">
                          mdi-pencil
                        </v-icon>
                      </v-btn>
                    </template>
                    {{ $t("EDIT") }}
                  </v-tooltip>
                  <v-tooltip top transition="slide-y-reverse-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        depressed
                        color="error"
                        @click="$refs.deleteDialogComponent.open(item)"
                        x-small
                        v-bind="attrs"
                        v-on="on"
                        class="rounded-sm"
                        outlined
                      >
                        <v-icon size="15">
                          delete
                        </v-icon>
                      </v-btn>
                    </template>
                    {{ $t("DELETE") }}
                  </v-tooltip>
                </td>
              </tr>
              </template>
            <template v-else>
              <tr>
                <td colspan="7" class="text-center vertical-middle font-weight-bold font-italic" style="color:red">
                  {{ $t('NO_DATA') }}
                </td>
              </tr>
            </template>
          </tbody>
        </template>
      </v-simple-table>
      <paging
        v-if="paging.total"
        :paging.sync="paging"
        @changePage="changePage"
      >
        <span slot="totalItems" v-if="paging"
          >{{ $t("TOTAL") }}: {{ paging.total }} {{ $t("PACKAGE") }}</span
        >
      </paging>
      <delete-dialog @deleteItem="deleteItem" ref="deleteDialogComponent">
        <span slot="title"
          >{{ $t("CONFIRM_DELETE_RESTRICTION") }}?</span
        >
      </delete-dialog>
    </div>
  </div>
</template>

<script>
import Paging from "@/components/Utils/Paging.vue";
import DeleteDialog from "@/components/Utils/DeleteDialog.vue";
import { restriction } from "@/_services/SaleRoom/restriction.js";
import { _alert } from "@/_helpers/function.js";
export default {
  components: {
    "delete-dialog": DeleteDialog,
    paging: Paging
  },
  data() {
    return {
      isLoading: false,
      systemLang: this.$i18n.locale,
      dialog: false,
      headers: [
        {
          text: this.$t("STT"),
          class: "text-center"
        },
        {
          text: this.$t("RESTRICTION_NAME"),
          value: "name",
          width: "18%",
        },
        {
          text: this.$t("STATUS"),
          class: "text-center",
          value: "status",
        },
        {
          text: this.$t("ACTION"),
          value: "action",
          class: "text-center"
        }
      ],
      data: [],
      dataTable: [],
      editedIndex: -1,
      editedItem: null,
      keyword: "",
      status: "all",
      paging: {
        total: 0,
        limit: 15,
        offset: 0
      },
      orderBy: "active",
      asc: false
    };
  },
  mounted: function() {
  },
  created() {
    this.initialize();
  },
  watch: {},
  methods: {
    async initialize() {
      if (this.$session.exists() && this.$session.getAll().ojbListRestriction) {
        this.paging.limit = this.$session.get("ojbListRestriction").limit;
        this.paging.offset = this.$session.get("ojbListRestriction").offset;
      }
      await this.getAll();
    },
    getAll(isSearching) {
      this.$session.set("ojbListRestriction", this.paging);
      if (isSearching) this.paging.offset = 0;
      let body = {};
      body.keyword = this.keyword;
      if (this.status === "all") {
        body.status = null;
      } else {
        body.status = this.status;
      }
      body.limit = this.paging.limit;
      body.offset = this.paging.offset;
      body.orderBy = this.orderBy;
      body.asc = this.asc;
      this.isLoading = true;
      restriction.getAllPackageRestriction(body).then(res => {
        this.data = res.data;
        this.dataTable = res.data;
        this.paging.total = res.total;
      }).finally(() => (this.isLoading = false));
    },
    changePage(paging) {
      this.paging = paging;
      this.getAll();
    },
    addNew() {
      this.$router.push({
        name: "detailPackageRestriction",
        params: { id: "00000000-0000-0000-0000-000000000000" }
      });
    },
    editItem(item) {
      this.editedIndex = this.data.indexOf(item);
      this.editedItem = Object.assign({}, item);
      this.$router.push({
        name: "detailPackageRestriction",
        params: { id: item.id }
      });
    },
    deleteItem(item) {
      const index = this.data.indexOf(item);
      restriction.deletePackageRestriction(item.id).then(res => {
        if (res.responseCode == 0) {
          this.initialize();
        }
        _alert(res, this.$t(res.data), false);
      });
    },
    changeStatus(item) {
      let body = {
        id: item.id,
        status: item.status ? 1 : 0
      };
      restriction.updatePackageRestrictionStatus(body).then(res => {
        _alert(res, this.$t(res.data), true);
      });
    }
  }
};
</script>
